import { InitialStateType, UiContextDispatchActions } from './types'

export const INITIAL_STATE: InitialStateType = {
	addressesSearchLoading: true,
	peekClassName: '',
	modalOpen: true,
	footerVisible: false,
	isFluid: false,
	navOpen: false,
	mapPeekOpen: false,
	mapPeekContent: null,
	peekOpen: false,
	peekContent: null,
	responsivePeek: false,
	hoveredListVehicle: null,
	pageTitle: '',
	dictionaryWords: null,
	theme: 'fod',
}

export const uiContextReducer = (state: InitialStateType, action: UiContextDispatchActions): InitialStateType => {
	switch (action.type) {
		case 'SET_THEME': {
			return { ...state, theme: action.payload }
		}
		case 'SET_DICTIONARY_WORDS': {
			return { ...state, dictionaryWords: action.payload }
		}
		case 'SET_PAGE_TITLE':
			return { ...state, pageTitle: action.payload }
		case 'SET_HOVERED_LIST_VEHICLE':
			return { ...state, hoveredListVehicle: action.payload }
		case 'SET_RESPONSIVE_PEEK':
			return { ...state, responsivePeek: action.payload }
		case 'SET_PEEK_CLASSNAME':
			return { ...state, peekClassName: action.payload }
		case 'SET_ADDRESSES_SEARCH_LOADING':
			return { ...state, addressesSearchLoading: action.payload }
		case 'DISPLAY_FOOTER':
			return { ...state, footerVisible: action.payload }
		case 'TOGGLE_MODAL':
			return { ...state, modalOpen: action.payload }
		case 'SET_NAV_OPEN':
			return { ...state, navOpen: action.payload }
		case 'SET_MAP_PEEK_OPEN':
			return { ...state, mapPeekOpen: action.payload }
		case 'SET_MAP_PEEK_CONTENT':
			return { ...state, mapPeekContent: action.payload }
		case 'SET_PEEK_OPEN':
			return { ...state, peekOpen: action.payload }
		case 'SET_PEEK_CONTENT':
			return { ...state, peekContent: action.payload }
		default:
			return { ...state }
	}
}
